import { render, staticRenderFns } from "./InterParcelService.vue?vue&type=template&id=14951e6a&"
import script from "./InterParcelService.vue?vue&type=script&lang=js&"
export * from "./InterParcelService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports